import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import DefaultReceiptDetails from '../../components/receipt/DefaultReceiptDetails'

import { makeGetOrder } from '../../selectors/order'
import { makeGetCurrentMenu } from '../../selectors/menus'
import { makeGetRevenueCenter } from '../../selectors/revenueCenter'

const mapStateToProps = (state, ownProps) => {
  const orderUuid = ownProps?.match?.params?.orderUuid ?? state?.order?.currentOrderId
  const getOrder = makeGetOrder()
  const getMenu = makeGetCurrentMenu()
  const getRevenueCenter = makeGetRevenueCenter()

  const menu = getMenu(state)
  const order = getOrder(state, orderUuid)
  const revenueCenter = getRevenueCenter(state, order.standUuid)


  return {
    order,
    revenueCenter,
    menuName: menu.name,
  }
}

export default withRouter(connect(mapStateToProps, undefined)(DefaultReceiptDetails))
